/**
 * Mini Prixia (Ronda X): el servidor avisa con la cabecera `X-Mision-Cumplida` que una
 * respuesta cumplió una misión de la demo; el interceptor de Axios lo pasa a este
 * evento del navegador y la tarjeta de misiones (sólo demo) lo escucha. Sin imports a
 * propósito: el interceptor no arrastra nada de la demo (ni ciclos de módulos).
 */
export const EVENTO_MISION_CUMPLIDA = 'prixia:mision-cumplida';

export function avisarMisionCumplida(mision: unknown): void {
  if (typeof mision !== 'string' || mision === '') return;
  try {
    window.dispatchEvent(new CustomEvent(EVENTO_MISION_CUMPLIDA, { detail: mision }));
  } catch {
    // Un aviso que no sale no puede romper la respuesta.
  }
}
